import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-flag-outline',
  standalone: false,
  templateUrl: './icon-flag.html',
  styleUrl: './icon-flag.scss',
})
export class IconFlagOutlineComponent {
  @Input() tooltip?: string;
}
